import { clearPhone } from './clearPhone';

export const isPhoneValid = (phone: string) => {
  const phoneNumber = clearPhone(phone);

  return /^\d{11}$/.test(phoneNumber);
};
